export default "__VITE_ASSET__DN70_nIX__"